import React from "react";
import { Box, Heading, Text, Divider, Link as ChakraLink, useColorModeValue } from "@chakra-ui/react";


function PrivacyPolicy() {
  return (
    <Box
      maxW="3xl"
      mx="auto"
      px={4}
      py={8}
      bg={useColorModeValue("white", "gray.800")}
      borderRadius="lg"
      boxShadow="md"
    >
      <Heading as="h1" size="xl" mb={4} color="teal.600" textAlign="center">
        Privacy Policy
      </Heading>
      <Divider mb={6} />

      <Text mb={3} fontSize="sm" color="gray.500" textAlign="center">
        <strong>Effective Date:</strong> July 20, 2025
      </Text>

      <Text mb={4} fontSize="md">
        Serena Space is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform and services.
      </Text>

      <Heading as="h2" size="md" mt={6} mb={2} color="teal.700">
        1. Information We Collect
      </Heading>
      <Text mb={4} fontSize="md">
        We may collect personal information such as your name, email, contact details, health and nutrition preferences, genetic/biomarker data (if provided), and payment information.
      </Text>

      <Heading as="h2" size="md" mt={6} mb={2} color="teal.700">
        2. How We Use Your Information
      </Heading>
      <Box as="ul" pl={6} mb={4} fontSize="md" style={{ listStyleType: "disc" }}>
        <li>Personalize your nutrition and meal plans</li>
        <li>Process orders and payments</li>
        <li>Communicate with you about your account and services</li>
        <li>Improve our products and services</li>
        <li>Comply with legal obligations</li>
      </Box>

      <Heading as="h2" size="md" mt={6} mb={2} color="teal.700">
        3. Data Sharing & Security
      </Heading>
      <Text mb={4} fontSize="md">
        We do not sell your personal data. We may share information with trusted partners (e.g., payment processors, labs) only as needed to deliver our services. We use industry-standard security measures to protect your data.
      </Text>

      <Heading as="h2" size="md" mt={6} mb={2} color="teal.700">
        4. Your Rights
      </Heading>
      <Text mb={4} fontSize="md">
        You have the right to access, update, or delete your personal information. Contact us at <ChakraLink href="mailto:support@serenaspace.com" color="teal.500">support@serenaspace.com</ChakraLink> for any privacy-related requests.
      </Text>

      <Heading as="h2" size="md" mt={6} mb={2} color="teal.700">
        5. Changes to This Policy
      </Heading>
      <Text mb={4} fontSize="md">
        We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on our website.
      </Text>

      <Heading as="h2" size="md" mt={6} mb={2} color="teal.700">
        6. Contact Us
      </Heading>
      <Text mb={2} fontSize="md">
        If you have any questions about this Privacy Policy, please contact us at{' '}
        <ChakraLink href="mailto:support@serenaspace.com" color="teal.500">
          support@serenaspace.com
        </ChakraLink>.
      </Text>
    </Box>
  );
}

export default PrivacyPolicy;

